import { DEFAULT_STATUS_KEY, StatusInfo } from 'src/core/StatusInfo';

export const RequestsStatusInfo: Record<string, StatusInfo> = {
    FOR_REVIEW: {
        color: 'var(--requests-forReview-color)',
        borderColor: 'var(--requests-forReview-border-color)',
        title: 'For review',
        backgroundColor: 'var(--requests-forReview-background)',
    },
    UNDER_REVIEW: {
        color: 'var(--requests-review-color)',
        borderColor: 'var(--requests-review-border-color)',
        title: 'Under review',
        backgroundColor: 'var(--requests-review-background)',
    },
    APPROVED: {
        color: 'var(--requests-approved-color)',
        borderColor: 'var(--requests-approved-border-color)',
        title: 'Approved',
        backgroundColor: 'var(--requests-approved-background)',
    },
    DECLINED: {
        color: 'var(--requests-declined-color)',
        borderColor: 'var(--requests-declined-border-color)',
        title: 'Declined',
        backgroundColor: 'var(--requests-declined-background)',
    },
    SIGNING: {
        color: 'var(--requests-signing-color)',
        borderColor: 'var(--requests-signing-border-color)',
        title: 'Signing',
        backgroundColor: 'var(--requests-signing-background)',
    },
    APPLIED: {
        color: 'var(--requests-applied-color)',
        borderColor: 'var(--requests-applied-border-color)',
        title: 'Applied',
        backgroundColor: 'var(--requests-applied-background)',
    },
    [DEFAULT_STATUS_KEY]: {
        color: '#91796c',
        borderColor: '#F4F0DF',
        title: '',
        backgroundColor: '#F4F0DF',
    },
};
